import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BfxBlotterFilterService } from "./bfx-blotter-filter.service";
import { AutoCompleteModule } from "@bfx/primeng/autocomplete";
import { CalendarModule } from "@bfx/primeng/calendar";
import { DataTableModule } from "@bfx/primeng/datatable";
import { DialogModule } from "@bfx/primeng/dialog";
import { DropdownModule } from "@bfx/primeng/dropdown";
import { InputSwitchModule } from "@bfx/primeng/inputswitch";
import { MenuModule } from "@bfx/primeng/menu";
import { MultiSelectModule } from "@bfx/primeng/multiselect";
import { RadioButtonModule } from "@bfx/primeng/radiobutton";
import { SelectButtonModule } from "@bfx/primeng/selectbutton";
import { SliderModule } from "@bfx/primeng/slider";
import { SpinnerModule } from "@bfx/primeng/spinner";
import { DatePipe } from "@angular/common";

// Modules
import { TranslateModule, TranslateCompiler } from "@ngx-translate/core";
import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { PerfectScrollbarModule } from "@bfx/ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "@bfx/ngx-perfect-scrollbar";

import { BfxPanelHelperService } from "../bfx-common/services/bfx-panel-helper.service";

import { BfxBlotterFilterListComponent } from "./bfx-blotter-filter-list.component";
import { BfxBlotterFilterViewComponent } from "./bfx-blotter-filter-view.component";
import { BfxBlotterFilterManagerComponent } from "./bfx-blotter-filter-manager.component";
import { BfxBlotterFilterSelectorComponent } from "./bfx-blotter-filter-selector.component";
import { BfxBlotterFilterSelectorService } from "./bfx-blotter-filter-selector.service";
import { BfxBlotterFilterBarComponent } from "./bfx-blotter-filter-bar.component";
import { BfxElementsLibraryModule } from "app/bfx-element-library/bfx-elements-library.module";
import { BfxInterfaceControlsModule } from "../bfx-interface-controls/bfx-interface-controls.module";
import { FlexLayoutModule } from "@angular/flex-layout";
import { BfxBlotterFilterTemperatureComponent } from "app/bfx-blotter-filter/bfx-blotter-filter-temperature.component";
import { BfxBlotterFilterStateComponent } from "app/bfx-blotter-filter/bfx-blotter-filter-state.component";
import { JSONPointerCompiler } from "../../shared/ngx-translate";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";
import { TieredMenuModule } from "@bfx/primeng/tieredmenu";
import { BaseComponentsModule } from "shared/base-components/base-components.module";
import { SplitButtonModule } from "@bfx/primeng/splitbutton";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  declarations: [
    BfxBlotterFilterListComponent,
    BfxBlotterFilterViewComponent,
    BfxBlotterFilterManagerComponent,
    BfxBlotterFilterSelectorComponent,
    BfxBlotterFilterTemperatureComponent,
    BfxBlotterFilterStateComponent,
    BfxBlotterFilterBarComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    DataTableModule,
    DialogModule,
    MultiSelectModule,
    SelectButtonModule,
    DropdownModule,
    AutoCompleteModule,
    SpinnerModule,
    SliderModule,
    InputSwitchModule,
    CalendarModule,
    RadioButtonModule,
    BfxElementsLibraryModule,
    NativeDesktopModule,
    PerfectScrollbarModule,
    BfxSharedModule,
    BfxInterfaceControlsModule,
    FlexLayoutModule,
    TieredMenuModule,
    BaseComponentsModule,
    MenuModule,
    SplitButtonModule,
    TranslateModule.forChild({
      compiler: { provide: TranslateCompiler, useClass: JSONPointerCompiler },
    }),
  ],
  exports: [
    BfxBlotterFilterTemperatureComponent,
    BfxBlotterFilterStateComponent,
    BfxBlotterFilterManagerComponent,
    BfxBlotterFilterBarComponent,
    BfxBlotterFilterSelectorComponent,
    BfxBlotterFilterListComponent,
    BfxBlotterFilterViewComponent,
    BfxBlotterFilterManagerComponent,
    BfxBlotterFilterSelectorComponent,
    BfxBlotterFilterTemperatureComponent,
    BfxBlotterFilterStateComponent,
    BfxBlotterFilterBarComponent,
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    BfxBlotterFilterService,
    BfxBlotterFilterSelectorService,
    DatePipe,
    BfxPanelHelperService,
  ],
  bootstrap: [BfxBlotterFilterManagerComponent],
})
export class BfxBlotterFilterModule {}
